export default __webpack_public_path__ + "static/media/elk-mono.960e7fdd.svg";